module.exports = __webpack_public_path__ + "img/signal_wifi_4_bar_lock.39827f4f.svg";